import { FC } from 'react';

import * as Styles from './loader.module.scss';
import { MessageBubble } from '../message-bubble/message-bubble';

interface LoaderProps {}

export const Loader: FC<LoaderProps> = () => {
    return (
        <MessageBubble isMine={false}>
            <div className="p-x-1">
                <div className={Styles.dotFlashing} />
            </div>
        </MessageBubble>
    );
};
